<template>
  <div class="success_playing page">
    <div class="logo"><img alt="logo" src="@/assets/logo.png"></div>
    <div class="p-5">

      <div class="imgpr">
        <kinesis-container>
          <kinesis-element :strength="20">
            <img src="@/assets/images/final-success.png" alt="">
          </kinesis-element>
        </kinesis-container>
      </div>

      <div class="p-3">
        <h3>تهانينا</h3>
        <p>
          <span>لقد تجاوزت اللعبة بأمتياز في وقت</span>
          <strong class="px-1">({{ resulttime }})</strong>
          <span>ث</span>
        </p>
        <strong>
          <span>الدرجة</span>
          <span class="px-1 resulttest">{{ resulttest }}</span>
        </strong>
      </div>

    </div>
    <router-link to="/"><button class="btn but_green">الرجوع للرئيسية</button></router-link>

    <div class="imgpr1">
      <kinesis-container>
        <kinesis-element :strength="70">
          <img src="@/assets/images/balloon1.png" alt="">
        </kinesis-element>
      </kinesis-container>
    </div>

    <div class="imgpr3">
      <kinesis-container>
        <kinesis-element :strength="50">
          <img src="@/assets/images/balloon3.png" alt="">
        </kinesis-element>
      </kinesis-container>
    </div>

  </div>
</template>

<script>
export default {
  name: "Success",
  props: ['result'],

  data() {
    return {
      resulttime: "",
      resulttest: "",

      audiofinish: 'https://previews.customer.envatousercontent.com/files/274107761/preview.mp3',
    }
  },

  created() {
    if (!this.result) {
      this.$router.push('/')
    } else {
      this.finalResult(this.result)
      this.playAudio(this.audiofinish)
      this.get_confetti()
    }
  },

  mounted() {

  },

  methods: {

    finalResult: function (val) {

      if (val <= 35) {
        this.resulttest = "ارتباط  وثيق"
        this.resulttime = "15 – 35"
      }

      if (val >= 36 && val <= 55) {
        this.resulttest = "ارتباط جيد جدا"
        this.resulttime = "36 – 55"
      }

      if (val >= 56 && val <= 75) {
        this.resulttest = "ارتباط جيد"
        this.resulttime = "56 - 75"
      }

      if (val >= 76 && val <= 100) {
        this.resulttest = "ارتباط مقبول"
        this.resulttime = "76 - 100"
      }

    },

    closeGoBack: function() {
      this.$router.push('/')
    },

    playAudio: function(audiofile) {
      var audio = new Audio(audiofile);
      audio.pause();
      audio.play();
    },

    get_confetti () {
      this.$confetti.start({
        particlesPerFrame: 0.5,
        particles: [
          {
            type: 'heart',
            colors: [
              'red',
              'pink',
            ],
          },
          {
            type: 'rect',
            colors: [
              '#006F44',
            ],
          },
        ],
      });
      setTimeout(() => this.$confetti.stop(), 3000);
    }
  },

  beforeDestroy() {
    this.$confetti.stop();
  },


}
</script>


<style lang="scss" scoped>
.success_playing {
  position: relative;
}
.resulttest {
  color: #F2B101;
}
.logo {
  padding: 20px;
  img {
    max-width: 250px;
  }
}
.imgpr1 {
  max-width: 400px;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
  img {
    width: 100%;
  }
}
.imgpr3 {
  max-width: 500px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  img {
    width: 100%;
  }
}
</style>
